<template>
  <div
    id="alert-bubble"
    class="tooltip-alert"
    :class="tooltipClasses"
  >
    <div class="bubble" v-bind:style="`background-color: ${gColors(color).hex}`">
      <h6><icon glyph="help-circle"/> {{title}}</h6>
      <slot/>
      <div class="tooltip-cta">
        <button
          class="btn white"
          v-bind:style="`color: ${gColors(color).hex}`"
          v-on:click="removeTooltip">Got it</button>
    </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import { gColors } from '~/modules/gColors/colors';
  import {createNode, teleport} from "~/modules/nodeManager";

  export default Vue.extend({
    inheritAttrs: false,
    props: {
      color: {
        type: String,
        default: 'Mariner',
      },
      title: {
        type: String,
      },
      direction: {
        type: String,
      }
    },
    data() {
      return {
        gColors: gColors,
      }
    },
    mounted() {
      const bubble = document.getElementById('alert-bubble');
      if(bubble){
        const bubblePositions = bubble.getBoundingClientRect();
        const aside = createNode({
          type: 'aside',
          attributes: [
            { name: 'id', value: 'pop-mask' },
            { name: 'class', value: 'pop-mask tooltip-alert' },
          ]
      });

        bubble.style.left = bubblePositions.left + 'px';
        bubble.style.top = bubblePositions.top + 'px';
        teleport.node(bubble, aside);
      }
    },
    methods: {
      removeTooltip($event){
        document.getElementById('pop-mask').remove();
        this.$emit('dismiss', $event);
      },
    },
    computed: {
      tooltipClasses() {
        return [
          this.alertColor,
          this.direction,
        ];
      }
    }
  });
</script>